import React, { useState, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { pendingNotifications } from './../../providers/api'
import Sidebar from "./sidebar";
// import { BellFill } from 'react-bootstrap-icons';
import "./navbar.css";
import { useEffect } from "react";
import UserMenu from "./UserMenu";
import LanguageSwitcher from "../LanguageSwitcher";
import BotonNavChatElite from "../ChatElite/panel/BotonNavChatElite";
import BreadCrumb from "../navbar/Breadcrumb";
import { useTranslation } from 'react-i18next';
import { getOneAAFF } from '../../services/aaffs.service';

function Navbar(props) {
  const { user, routes, routesClientes, routesPersonal, routesListados, routesDashboard, routesKae } = props;
  const [sidebar, setSidebar] = useState(true);
  const [checked, setChecked] = useState(true);
  const [aaff, setAaff] = useState({});
  const { t } = useTranslation('nav');
  const location = useLocation();

  const isNewProfile = user?.tieneLegalia && user.rol === "AAFF";

  // const breadcrumbs = useMemo(() => {
  //   const breadcrumbMap = {
  //     '/comunidades': t('breadcrumb.communities'),
  //     '/proveedores': t('breadcrumb.suppliers'),
  //     '/servicios': t('breadcrumb.services'),
  //     '/oficinas': t('breadcrumb.offices'),
  //     '/perfil': t('breadcrumb.profile'),
  //     '/aaff': t('breadcrumb.aaff'),
  //     // '/chat': t('breadcrumb.chat'),
  //   };

  //   const path = location.pathname;
  //   const segments = path.split('/').filter(Boolean);

  //   if (segments.length === 0) return [];

  //   const rutas = [];
  //   let currentPath = '';

  //   for (let i = 0; i < segments.length; i++) {
  //     currentPath += '/' + segments[i];
  //     const label = breadcrumbMap[currentPath];
  //     if (label) {
  //       rutas.push({ path: currentPath, label });
  //     } else if (i > 0) {
  //       const parentLabel = breadcrumbMap['/' + segments[0]];
  //       if (parentLabel && rutas.length === 1) {
  //         rutas.push({ path: currentPath, label: segments[i] });
  //       }
  //     }
  //   }

  //   return rutas;
  // }, [location.pathname, t]);
  

  useEffect(() => {
    // pendingNotifications().then(result => setNumNotification(result))
  }, []);

  const handleChange = (event) => {
    setChecked(!event.target.value);
    showSidebar();
  };

  const showSidebar = () => {
    setSidebar(!sidebar);
    props.showSidebar();
  };
  

  return (
    <>
      <Sidebar
        sidebar={sidebar}
        checked={checked}
        rol={user.rol}
        routes={routes}
        routesClientes={routesClientes}
        routesPersonal={routesPersonal}
        routesListados={routesListados}
        routesDashboard={routesDashboard}
        routesKae={routesKae}
      />

      <nav className={`navbar navbar-light justify-content-between`} style={isNewProfile ? { boxShadow: 'none', borderBottom: '1px solid rgba(0,0,0,0.10)', backgroundColor: 'rgb(243,244,246)'} : {backgroundColor: 'white', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
        <div className="container-fluid">
          {/* <button className="navbar-brand btn" onClick={() => showSidebar()}><SquareHalf /></button> */}
          <div className="check-menu form-switch">
            {!user.tieneLegalia && 
              <label className="switch">
                <input
                  type="checkbox"
                  value={checked}
                  checked={checked ? checked : null}
                  onChange={handleChange}
                />
                <span className="slider"></span>
              </label>
            }

            {/* {isNewProfile && <BreadCrumb rutas={breadcrumbs} style={{ margin: '0 10px'}} />} */}

          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <BotonNavChatElite />
            <LanguageSwitcher />
            <UserMenu />
          </div>
        </div>
      </nav>
      <style jsx="true">{`
          .dropdown-toggle:after {
            display: none !important;
          }              
      `}</style>
    </>
  );
}

export default Navbar;
